module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultationRegistration paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("咨询注册")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('label', {
    staticClass: "uploadSFZ",
    attrs: {
      "for": "upload"
    }
  }, [_vm._v("上传身份证图片")]), _vm._v(" "), _c('input', {
    ref: "uploadref",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "upload",
      "accept": "image/*"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px 0 0",
      "text-align": "center"
    }
  }, [_vm._v("说明：上传身份证可免填以下身份证信息")]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "基本信息"
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "right",
      "title": "姓名",
      "placeholder": "请输入姓名"
    },
    on: {
      "on-blur": _vm.emtpvalidate
    },
    model: {
      value: (_vm.basemessage.name),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "name", $$v)
      },
      expression: "basemessage.name"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.nameIcon),
      expression: "iconData.nameIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "keyboard": "number",
      "text-align": "right",
      "title": "电话号码",
      "placeholder": "请输入电话号码"
    },
    on: {
      "on-blur": _vm.telchange
    },
    model: {
      value: (_vm.basemessage.phone),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "phone", $$v)
      },
      expression: "basemessage.phone"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.phoneIcon),
      expression: "iconData.phoneIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('popup-radio', {
    attrs: {
      "title": "证件类型",
      "placeholder": "请选择",
      "options": _vm.certType
    },
    on: {
      "on-change": _vm.certTypechange
    },
    model: {
      value: (_vm.basemessage.idType),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "idType", $$v)
      },
      expression: "basemessage.idType"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.idTypeIcon),
      expression: "iconData.idTypeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "novalidate": "",
      "text-align": "right",
      "title": "证件号码",
      "placeholder": "请输入证件号码"
    },
    on: {
      "on-blur": _vm.SFZvalidate
    },
    model: {
      value: (_vm.basemessage.identyId),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "identyId", $$v)
      },
      expression: "basemessage.identyId"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.certTypeIcon),
      expression: "iconData.certTypeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.identyIdIcon),
      expression: "iconData.identyIdIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brithSexshow),
      expression: "brithSexshow"
    }],
    staticClass: "relative"
  }, [_c('datetime', {
    attrs: {
      "title": "出生日期",
      "min-year": new Date().getFullYear() - 70,
      "max-year": new Date().getFullYear() - 1,
      "placeholder": "请选择出生日期"
    },
    on: {
      "on-change": _vm.emtpvalidate
    },
    model: {
      value: (_vm.basemessage.brithDate),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "brithDate", $$v)
      },
      expression: "basemessage.brithDate"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.brithDateIcon),
      expression: "iconData.brithDateIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brithSexshow),
      expression: "brithSexshow"
    }],
    staticClass: "relative"
  }, [_c('popup-radio', {
    attrs: {
      "title": "性别",
      "placeholder": "请选择",
      "options": _vm.sexoptions
    },
    on: {
      "on-change": _vm.sexchange
    },
    model: {
      value: (_vm.basemessage.sex),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "sex", $$v)
      },
      expression: "basemessage.sex"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconData.sexIcon),
      expression: "iconData.sexIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)]), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "margin": "15px auto",
      "width": "95%"
    },
    attrs: {
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "width": "250px",
      "time": 1000,
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d491ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/internetHospital/consultationRegistration.vue
// module id = 4llu
// module chunks = 6